import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { SITE } from "@/config/site";
import { useLanguage } from "@/i18n/LanguageContext";

// Identificação do prestador de serviços (artigo 10.º do Decreto-Lei n.º 7/2004).
// A morada sai do rodapé e das secções comerciais, mas tem de continuar acessível: fica aqui.
export default function InformacaoLegal() {
  const { t } = useLanguage();
  const rows = [
    [t("legal.name"), SITE.legalName],
    [t("legal.nif"), SITE.nif],
    [t("legal.seat"), SITE.seat],
    [t("legal.email"), <a key="m" href={`mailto:${SITE.email}`} className="underline underline-offset-4 hover:text-[#C2A675] transition-colors">{SITE.email}</a>],
  ];

  return (
    <div data-testid="legal-page" className="pt-20">
      <Seo title={t("seo.legal.title")} description={t("seo.legal.desc")} />
      <section className="pt-16 lg:pt-20 pb-20 max-w-4xl mx-auto px-6">
        <Reveal>
          <span className="mono-tag text-xs uppercase tracking-[0.22em] text-[#C2A675]">{t("legal.tag")}</span>
          <h1 className="serif-display text-4xl sm:text-5xl font-light text-white mt-4 mb-4">{t("legal.title")}</h1>
          <p className="text-sm text-[#A8A6A0] font-light mb-12 max-w-2xl">{t("legal.intro")}</p>
        </Reveal>
        <Reveal>
          <dl className="border-t border-white/10">
            {rows.map(([k, v]) => (
              <div key={k} className="grid grid-cols-1 sm:grid-cols-[14rem_1fr] gap-1 sm:gap-6 py-5 border-b border-white/10">
                <dt className="text-[11px] uppercase tracking-[0.16em] text-[#A8A6A0]">{k}</dt>
                <dd className="text-base text-[#E8E6E1] font-light">{v}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </section>
    </div>
  );
}
